import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";


export const fetchDeleteHomeworkFile = createAsyncThunk(
    "lessons/deleteHomeworkFile",
    async ({ lessonId, filePath }: { lessonId: string | undefined; filePath: string }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.delete(`/api/lessons/${lessonId}/homework-file`, {
                data: {
                    file: filePath,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });

            if (response.data.success) {
                return response.data;
            } else {
                console.error("Ошибка при обновлении урока:", response.data.error);
            }
        } catch (error) {
            console.error("An error occurred:", error);
            return thunkAPI.rejectWithValue("Error deleting file.");
        }
    }
);
